<app-lnr-okta-callback [error]="error"></app-lnr-okta-callback>
